import i18next from 'i18next';

export const getFirstSuccessfulPayment = (payments = []) => {
  const [firstItemPayment] = payments || [];
  return i18next.t(`OrdersDetails:${firstItemPayment.type}`);
};
